export default __webpack_public_path__ + "static/media/img-uncheck.41b4b92f.svg";